import React from "react";
import Template from "../components/Template";
import BreadCrumb from "../components/BreadCrumb";

function Hit() {
  return (
    <Template>
      <BreadCrumb pageName="High-Intensity Training" />

      <section className="section-lgx">
        <div className="container">
          <div className="row g-0">
            <div className="col-12 pbmit-footer-right">
              <h2
                style={{
                  textAlign: "center",
                  marginBottom: "30px",
                  color: "#05AAE3",
                }}
              >
                Description
              </h2>
            </div>
            <div className="col-xl-5 col-lg-12">
              <img
                src="assets/images/bg/about-img-01.jpg"
                className="img-fluid"
                style={{ width: "95%", height: "auto", margin: "0px auto" }}
                alt=""
              />
            </div>

            <div
              className="col-xl-7 col-lg-12"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div>
                <div className="pbmit-heading-subheading animation-style1 mb-4">
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 25,
                      textTransform: "uppercase",
                      display: "block",
                    }}
                  >
                    What’s Included
                  </span>
                </div>

                <p>
                  <b>
                    Our Beginner’s Programme gives you complete access to
                    structured training designed to build strength, boost
                    energy, and develop long-term consistency.
                  </b>
                </p>

                <div className="pbmit-heading-subheading animation-style1 mb-4">
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 25,
                      textTransform: "uppercase",
                      display: "block",
                      color: "#EFC018",
                    }}
                  >
                    Group Classes
                  </span>
                </div>

                <ul className="list-group list-group-borderless">
                  <li className="list-group-item">HIIT workouts</li>
                  <li className="list-group-item">Strength training</li>

                  <li className="list-group-item">Functional training</li>
                </ul>

                <div className="pbmit-heading-subheading animation-style1 mb-4">
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 25,
                      textTransform: "uppercase",
                      display: "block",
                      color: "#EFC018",
                    }}
                  >
                    1:1 Coaching
                  </span>
                </div>
                <ul className="list-group list-group-borderless">
                  <li className="list-group-item">
                    Three coached sessions per week with flexible timings
                  </li>
                </ul>
                <div className="pbmit-heading-subheading animation-style1 mb-4">
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 25,
                      textTransform: "uppercase",
                      display: "block",
                      color: "#EFC018",
                    }}
                  >
                    Tailor-made nutrition plan from our in-house nutritionist
                  </span>
                </div>
                <p>
                  This programme is thoughtfully designed to help beginners
                  build a strong physical and mental foundation without feeling
                  overwhelmed.
                </p>
              </div>
            </div>

            {/* <div className="col-12">
              <div className="pbmit-heading-subheading animation-style1 mb-4">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: 25,
                    textTransform: "uppercase",
                    display: "block",
                  }}
                >
                  Summary
                </span>
              </div>
              <ul className="list-group list-group-borderless">
                <li className="list-group-item">
                  Three coached sessions per week
                </li>
                <li className="list-group-item">Personalised nutrition plan</li>
                <li className="list-group-item">
                  Advance booking required (minimum of 2 days)
                </li>
              </ul>
            </div> */}
          </div>
        </div>
      </section>

      <hr />

      <section className="section-lgx">
        <div className="container">
          <div className="row g-0">
            <div
              className="col-xl-7 col-lg-12"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div>
                <div className="pbmit-heading-subheading animation-style1 mb-4">
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 25,
                      textTransform: "uppercase",
                      display: "block",
                    }}
                  >
                    SUMMARY
                  </span>
                </div>

                <ul className="list-group list-group-borderless">
                  <li className="list-group-item">
                    Three coached sessions per week
                  </li>
                  <li className="list-group-item">
                    Personalised nutrition plan
                  </li>
                  <li className="list-group-item">
                    Advance booking required (minimum of 2 days)
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-5 col-lg-12">
              <img
                src="https://static.vecteezy.com/system/resources/thumbnails/056/018/451/small/gray-diamond-background-photo.jpg"
                className="img-fluid"
                style={{ width: "95%", height: "auto", margin: "0px auto" }}
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <hr />

      <section className="section-lgx">
        <div className="container">
          <div className="row g-0">
            <div className="col-xl-5 col-lg-12">
              <img
                src="https://cdn.shopify.com/s/files/1/0430/6533/files/OzQvwVeWEiOYq8VxemYHLNGyA2Sx3OJ91614347671.jpg?v=1614787195"
                className="img-fluid"
                style={{ width: "95%", height: "auto", margin: "0px auto" }}
                alt=""
              />
            </div>

            <div
              className="col-xl-7 col-lg-12"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div>
                <div className="pbmit-heading-subheading animation-style1 mb-4">
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 25,
                      textTransform: "uppercase",
                      display: "block",
                    }}
                  >
                    EQUIPMENT REQUIRED
                  </span>
                </div>

                <ul className="list-group list-group-borderless">
                  <li className="list-group-item">Dumbbell (2kg to 10kg)</li>
                  <li className="list-group-item">Ankle weights (optional)</li>
                  <li className="list-group-item">Kettle bell (optional)</li>
                  <li className="list-group-item">Resistance band</li>
                  <li className="list-group-item">Yoga mat</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About End */}
    </Template>
  );
}

export default Hit;
